<template>
    <div>
        <rkm-modal
            extra-large
            persistent
            ref="RkmModal"
            title="Reagendamento"
        >

            <rkm-alert show info>
                <strong>
                    {{ others.moment(this.date).format('DD/MM/YYYY') }} - {{ getStringDiaSemana(others.moment(this.date).day() + 1) }}
                </strong>
            </rkm-alert>

            <rkm-form
                ref="RkmForm"
                show-legend
            >
                <rkm-area
                    no-margin-top
                    title="Agendamentos"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields.agendamento"
                                :items="agendamentos"
                                @filter-changed="handleAgendamentoFilterChanged"
                                @filtered="agendamentosFiltered = $event"
                            >
                                <template v-slot:head(checkbox)>
                                    <rkm-form-checkbox
                                        :indeterminate="indeterminate"
                                        :value="true"
                                        @change="checkUncheckAll"
                                        v-model="checkedAll"
                                    />
                                </template>

                                <template v-slot:cell(pacienteTelefones)="{ item }">
                                    {{ handlePhone(item.pacienteTelefones) }}
                                </template>

                                <template v-slot:cell(checkbox)="{item}">
                                    <rkm-form-checkbox
                                        :value="true"
                                        @change="handleCheckboxChange(item.id)"
                                        v-model="item.selecionado"
                                    />
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area
                    title="Jornadas"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields.jornada"
                                :items="data.model.destino.jornadas"
                                @filtered="data.model.destino.jornadaId = null"
                            >
                                <template v-slot:cell(radio)="{item}">
                                    <rkm-form-radio
                                        :value="item.jornadaId"
                                        name="jornada"
                                        v-model="data.model.destino.jornadaId"
                                        :disabled="handleDisabled()"
                                    />
                                </template>

                                <template v-slot:cell(quantidadeConsulta)="{item}">
                                    {{vagasPreenchidas(item)}} / {{item.vagas}}
                                </template>

                                <template v-slot:cell(semanaId)="{item}">
                                    {{getStringDiaSemana(item.semanaId)}}
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-form>

            <template v-slot:footer>
                <rkm-button @click="close">
                    Cancelar
                </rkm-button>

                <rkm-button
                    @click="reschedule"
                    color="primary"
                    :disabled="data.model.destino.jornadaId == null"
                >
                    Salvar
                </rkm-button>
            </template>
        </rkm-modal>

        <ModalSupervisor
            @authorized="handleModalSupervisorAuthorized"
            @canceled="handleModalSupervisorCanceled"
            ref="ModalSupervisor"
        />
    </div>
</template>

<script>
// Components.
import ModalSupervisor from '@/components/exame-imagem/reagendamento-cancelamento-exame/components/permissao/Modal'

// Enums.
import agendamentoTipo from '@/enums/ambulatorio/agendamentoTipo'
import tipoControleJornada from '@/enums/exame-imagem/tipoControleJornada'
import statusJornada from '@/enums/exame-imagem/statusJornada'
import diasSemana from '@/enums/exame-laboratorial/diasSemana'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {ModalSupervisor},
    computed: {
        quantidadeAgendamentos() {

            return this.agendamentosFiltered.length
        },
        quantidadeAgendamentosSelecionados() {

            return this.agendamentos
                .filter(agendamento => agendamento.selecionado === true).length
        },
        validations() {
            return {
                motivoAgendamentoExcedente: {
                    required: true,
                    max: 500,
                },
            }
        },
    },
    created() {
        this.repositories = {
            reagendamentoExame: this.getConectaSusRepository('exameImagem.reagendamentoExame'),
        }
    },
    data: () => ({
        supervisorId: null,
        agendamentos: [],
        agendamentosOrigem: [],
        agendamentosFiltered: [],
        checkedAll: false,
        date: null,
        enums: {agendamentoTipo, tipoControleJornada, statusJornada, diasSemana},
        fields: {
            agendamento: [
                {key: 'checkbox', label: '#', class: 'col-min text-center'},
                {key: 'horaExame', label: 'Horário'},
                {key: 'paciente.nome', label: 'Nome'},
                {key: 'paciente.dataNascimento', label: 'Data de nascimento'},
                {key: 'paciente.prontuario', label: 'Prontuário'},
                {key: 'pacienteTelefones', label: 'Telefone'},
                {key: 'usuario', label: 'Agendador'},
            ],
            jornada: [
                {key: 'radio', label: '#', class: 'col-min text-center'},
                {key: 'data', label: 'Data'},
                {key: 'semanaId', label: 'Dia da semana'},
                {key: 'horaInicial', label: 'Início'},
                {key: 'horaFim', label: 'Fim'},
                {key: 'quantidadeConsulta', label: 'Quantidade agendados / vagas',  class: 'col-min text-center'},
            ],
        },
        indeterminate: false,
        isSupervisor: false,
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(date) {
            this.reset()

            this.date = date
            this.agendamentosOrigem = this.data.model.origem.agendamentos

            this.$refs.RkmModal.show()

            this.load()
        },
        load() {
            this.setLoading()

            this.getJornadas(this.date).then(responseJornadas => {

                if (this.data.model.destino.usuarioId) {
                    this.agendamentos = Object.assign(this.data.model.origem.agendamentos
                        .filter(agendamento => agendamento.data === this.others.moment(this.date).format('DD/MM/YYYY'))
                        .map(agendamento => ({...agendamento, selecionado: false})))
                } else {
                    this.agendamentos = Object.assign(responseJornadas.data.agendamentos.map(agendamento => ({...agendamento, selecionado: false})))
                }

                this.data.model.destino.jornadas = Object.assign(responseJornadas.data.jornadas)
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        loadAgendamentos() {

            this.setLoading()

            this.getAgendamentos(this.date).then(responseJornadas => {

                this.agendamentosOrigem = Object.assign(responseJornadas.data.agendamentos.map(agendamento => ({...agendamento, selecionado: false})))
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        handleAgendamentoFilterChanged() {
            this.checkedAll = false
            this.indeterminate = false
            this.agendamentos.map(agendamento => agendamento.selecionado = false)
        },
        checkUncheckAll(value) {
            this.checkedAll = value
            this.indeterminate = false
            this.data.model.destino.jornadaId = null

            this.agendamentos
                .filter(agendamento => this.agendamentosFiltered.find(agendamentoFiltered => agendamentoFiltered.id === agendamento.id))
                .map(agendamento => agendamento.selecionado = value)
        },
        handleCheckboxChange() {
            this.checkedAll = false
            this.indeterminate = false
            this.data.model.destino.jornadaId = null

            if (this.quantidadeAgendamentosSelecionados > 0) {
                if (this.quantidadeAgendamentosSelecionados === this.quantidadeAgendamentos) {
                    this.checkedAll = true
                } else  {
                    this.indeterminate = true
                }
            }
        },
        handleModalSupervisorCanceled() {
            this.supervisorId = null
            this.data.model.destino.jornadaId = null
        },
        handleModalSupervisorAuthorized(supervisorId) {
            this.supervisorId = supervisorId
            this.isSupervisor = true
            this.reschedule()
        },
        async getJornadas(data) {
            const request = {
                unidade_id: this.data.model.destino.unidadeId || this.data.model.origem.unidadeId,
                infraestrutura_id: this.data.model.destino.infraestruturaId || this.data.model.origem.infraestruturaId,
                exame_id: this.data.model.destino.grupoId || this.data.model.origem.grupoId,
                prestador_id: this.data.model.destino.prestadorId || this.data.model.origem.prestadorId,
                profissional_id: this.data.model.destino.usuarioId || this.data.form.usuario.id,
                data: this.others.moment(data).format('YYYY-MM-DD'),
            }

            return this.repositories.reagendamentoExame.getJornadas(this.camelObjectKeysToSnakeRecursive(request))
        },
        async getAgendamentos() {
            const request = {
                unidade_id: this.data.model.origem.unidadeId,
                infraestrutura_id: this.data.model.origem.infraestruturaId,
                exame_id: this.data.model.origem.grupoId,
                prestador_id: this.data.model.origem.prestadorId,
                profissional_id: this.data.form.usuario.id,
            }

            return this.repositories.reagendamentoExame.getJornadas(this.camelObjectKeysToSnakeRecursive(request))
        },
        reschedule() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const agendamentos = this.agendamentos
                        .filter(agendamento => agendamento.selecionado === true)

                    const request = {
                        agendamentos: agendamentos,
                        jornadaId: this.data.model.destino.jornadaId,
                        supervisorId: this.supervisorId,
                    }

                    this.setLoading()

                    this.repositories.reagendamentoExame.reschedule(this.camelObjectKeysToSnakeRecursive(request))
                        .then((response) => {

                            if (response.data.requiresSupervisor || response.data.requiresSupervisorJornada) {

                                let msg;

                                if (response.data.requiresSupervisorJornada) {

                                    msg = `Para prosseguir com o reagendamento, é necessário informar os dados do
                                        supervisor, pois o número de agendamentos excedeu as vagas disponíveis para a
                                        jornada. Deseja continuar?`;
                                } else {

                                    msg = `Para prosseguir com o reagendamento, é necessário informar os dados do
                                        supervisor, pois a cota para o período foi ultrapassada. Deseja continuar?`;
                                }

                                this.showAlert(msg, 'Atenção');

                                this.showConfirmation(msg, async () => {
                                    this.$refs.ModalSupervisor.open();
                                });

                                return false;
                            } else {

                                this.showSaveNotification()
                                this.resetAgendamentos()
                                this.loadAgendamentos()
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        close() {
            this.reset()
            this.$refs.RkmModal.hide()

            this.$emit('closed')
        },
        reset() {
            this.agendamentos = []
            this.agendamentosOrigem = []
            this.agendamentosFiltered = []
            this.checkedAll = false
            this.indeterminate = false
            this.isSupervisor = false
            this.data.model.destino.jornadas = []
            this.data.model.destino.jornadaId = null
            this.supervisorId = null
        },
        resetAgendamentos() {
            this.checkedAll = false
            this.indeterminate = false
            this.isSupervisor = false
            this.data.model.destino.jornadaId = null

            this.agendamentos = this.agendamentos.filter(agendamento => agendamento.selecionado === false)
        },
        vagasPreenchidas(agendamento) {

            let vagasPreenchidas = 0

            if(agendamento.controleJornadaId == this.enums.tipoControleJornada.EXAME){

                this.agendamentosOrigem.filter(item => item.data === agendamento.data)
                    .map(exameIncluido => {

                        vagasPreenchidas = vagasPreenchidas + exameIncluido.incluido.length
                    })

                    return vagasPreenchidas

            } else {

                vagasPreenchidas = this.agendamentosOrigem.filter(item => item.data === agendamento.data).length;

                return vagasPreenchidas
            }
        },
        getStringDiaSemana(dia) {

            if(dia == this.enums.diasSemana.DOMINGO) {

            return 'DOMINGO'
            } else if (dia == this.enums.diasSemana.SEGUNDA_FEIRA) {

            return 'SEGUNDA-FEIRA'
            } else if (dia == this.enums.diasSemana.TERCA_FEIRA) {

            return 'TERÇA-FEIRA'
            } else if (dia == this.enums.diasSemana.QUARTA_FEIRA) {

            return 'QUARTA-FEIRA'
            } else if (dia == this.enums.diasSemana.QUINTA_FEIRA) {

            return 'QUINTA-FEIRA'
            } else if (dia == this.enums.diasSemana.SEXTA_FEIRA) {

            return 'SEXTA-FEIRA'
            } else if (dia == this.enums.diasSemana.SABADO) {

            return 'SÁBADO'
            }
        },
        handlePhone(obj) {

            let telefones = ''

            Object.keys(obj).forEach(function(value, i) {

                if (i === 0) {
                    telefones = telefones.concat(obj[value])
                } else {
                    telefones = telefones.concat(`, ${obj[value]}`)
                }
            });

            return telefones
        },
        handleDisabled() {

            return this.agendamentos.filter(agendamento => agendamento.selecionado).length === 0
        }
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {type: Object, required: true},
        usuarioId: {type: Number, required: true},
    },
    watch: {
        agendamentos(value) {

            this.agendamentosFiltered = value
            this.checkedAll = false
            this.indeterminate = false
        },
    },
}
</script>